import React, { useState, useEffect } from "react";

import {
    Box,
    Button,
    ButtonGroup,
    Grid,
    IconButton,
    Modal,

} from "@mui/material";

import tableIcons from "../tableFormatting/tableIcons";

import CreatorWizard from "./CreatorWizard"
import StudentWizard from "./StudentWizard"

import PNGLogo from "../../images/perleto v3 logo.png";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4
  };

const WizardModal = ({ auth, counter, isNewUser, wizardHelp }) => {

    // const [externalHelp, setExternalHelp] = useState(false);

    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);

    const handleClose = () => {
        setOpen(false);
        setHelpOption(0)
    }

    const [helpOption, setHelpOption] = useState(0);

    useEffect(() => {
        if(wizardHelp == true) {
            setOpen(true)
        } 
        if(isNewUser == true) {
            setOpen(true)
        } 
    }, [counter]);

    const handleHelpOption = (e) => {
        if(e == 1) {
            setHelpOption(1)
        }
        if(e == 2) {
            setHelpOption(2)
        }
    }


    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <IconButton style={{ position: "absolute", right: "10px", marginTop: "-20px" }} onClick={() => handleClose()}>
                    <tableIcons.Close color="primary" />
                </IconButton>
                <Grid
                    container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justify="center"
                    style={{ marginBottom: "30px" }}
                >
                    <img src={PNGLogo} alt="header-logo" className="header-logo" style={{ width: "160px" }} />

                     <div style={{ padding: "20px 0 20px 0", textAlign: "center" }}>
                        {helpOption == 0 ? (
                            <>
                            {isNewUser == true ? (
                                <>
                                    <h2 style={{ marginBottom: "20px" }}>
                                    Welcome {auth.auth.displayName}! 
                                    </h2>
                                    <p>As this is your first time, we suggest that you explore some of the features here.</p>
                                    <p>Please select the materials that best suit you:</p>
                                    <ButtonGroup style={{ margin: "40px 0 0 0" }}>
                                        <Button variant="outlined" onClick={() => handleHelpOption(1)}>Content Creation</Button>
                                        <Button variant="outlined" onClick={() => handleHelpOption(2)}>Content Studying</Button>
                                    </ButtonGroup>

                                </>
                            ) : isNewUser == false ? (
                                <>
                                    <h2 style={{ marginBottom: "40px" }}>
                                        Hi {auth.auth.displayName}!
                                    </h2>
                                    <p>Please select the materials that you need help with:</p>
                                    <ButtonGroup style={{ margin: "40px 0 0 0" }}>
                                        <Button variant="outlined" onClick={() => handleHelpOption(1)}>Content Creation</Button>
                                        <Button variant="outlined" onClick={() => handleHelpOption(2)}>Content Studying</Button>
                                    </ButtonGroup>
                                </>
                            ) : (
                                <div>Error</div>
                            )}
                            </>
                        ) : helpOption == 1 ? (
                            <CreatorWizard />
                        ) : helpOption == 2 ? (
                            <StudentWizard />
                        ) : (
                            <div>Error</div>
                        )}
                            
                    </div>
                </Grid>
            </Box>
        </Modal>

        )
};


export default WizardModal;